// Cookies.jsx
import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./Terms.css"; // Reutilizar estilos de Terms

export default function Cookies() {
  return (
    <>
      <Helmet>
        <title>Política de Cookies | Wayo</title>
        <meta name="description" content="Política de cookies de Wayo. Información sobre cookies, análisis y rastreo en nuestra plataforma." />
        <meta name="keywords" content="cookies, política cookies, google analytics, rastreo" />
        <link rel="canonical" href="https://wayoai.app/cookies" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Política de Cookies | Wayo" />
        <meta property="og:description" content="Información sobre las cookies que usamos en Wayo" />
        <meta property="og:url" content="https://wayoai.app/cookies" />
        <meta property="og:type" content="website" />
      </Helmet>

      <main className="terms-page">
        <Header />
        
        <section className="terms-content">
          <div className="terms-container">
            <h1>Política de Cookies</h1>
            <p className="last-updated">Última 
actualización: 7 de diciembre de 2025</p>

            <div className="terms-section">
              <h2>¿Qué son las cookies?</h2>
              <p>
                Las cookies son pequeños archivos de 
texto que se almacenan en tu dispositivo 
                cuando visitas nuestro sitio web. Nos 
ayudan a mejorar tu experiencia y 
                entender cómo usas nuestros servicios.
              </p>
            </div>

            <div className="terms-section">
              <h2>Cookies que utilizamos</h2>
              
              <h3>1. Cookies esenciales</h3>
              <p>
                Necesarias para el funcionamiento básico 
del sitio. No se pueden desactivar.
              </p>
              
              <h3>2. Cookies de análisis (Google 
Analytics)</h3>
              <p>
                Nos ayudan a entender cómo los 
visitantes interactúan con nuestro sitio:
              </p>
              <ul>
                <li><strong>_ga:</strong> Distingue 
usuarios únicos (duración: 2 años)</li>
                <li><strong>_gid:</strong> Distingue 
usuarios únicos (duración: 24 horas)</li>
                <li><strong>_gat:</strong> Limita la 
velocidad de peticiones (duración: 1 minuto)</li>
              </ul>
              <p>
                <strong>Nota:</strong> Tenemos activada 
la anonimización de IP para proteger tu privacidad.
              </p>
            </div>

            <div className="terms-section">
              <h2>Gestionar cookies</h2>
              <p>
                Puedes controlar y eliminar las cookies 
según prefieras:
              </p>
              <ul>
                <li>
                  <strong>Chrome:</strong> Configuración 
→ Privacidad y seguridad → Cookies
                </li>
                <li>
                  <strong>Firefox:</strong> Preferencias 
→ Privacidad y seguridad
                </li>
                <li>
                  <strong>Safari:</strong> Preferencias 
→ Privacidad
                </li>
              </ul>
              <p>
                Ten en cuenta que eliminar o bloquear 
cookies puede afectar la funcionalidad 
                del sitio.
              </p>
            </div>

            <div className="terms-section">
              <h2>Cambios en esta política</h2>
              <p>
                Podemos actualizar esta política de 
cookies ocasionalmente. Te notificaremos 
                de cualquier cambio importante 
actualizando la fecha de "Última actualización" 
                en la parte superior.
              </p>
            </div>

            <div className="terms-section">
              <h2>Contacto</h2>
              <p>
                Si tienes preguntas sobre nuestra 
política de cookies:
              </p>
              <ul>
                <li>Email: <a 
href="mailto:soporte@wayoai.app">soporte@wayoai.app</a></li>
              </ul>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}
